var map = {
	"./books.png": 897,
	"./breadcrumb.svg": 1565,
	"./databases.png": 898,
	"./digital_books.png": 899,
	"./earning.svg": 1566,
	"./flag_ec.png": 1567,
	"./flag_usa.png": 1568,
	"./mui-logo.svg": 1569,
	"./news.png": 900,
	"./notification.svg": 1570,
	"./scientific_publications.png": 901,
	"./social-google.svg": 1571,
	"./tesis.png": 902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1564;